import { tap } from './functional-utils';
import { PIPE_RETURN_SYMBOL, catchType, catcher, createPipeReturn, createPipeThrow, } from './syncPipe';
export function asyncPipe(a, ...steps) {
    return runAsyncPipe([], a, ...steps);
}
function isPipeReturn(value) {
    return (value !== null &&
        typeof value === 'object' &&
        'kind' in value &&
        value.kind === PIPE_RETURN_SYMBOL);
}
function isPromise(value) {
    return (value !== null &&
        typeof value === 'object' &&
        typeof value.then === 'function');
}
const isCatchFunction = (step) => typeof step === 'function' &&
    '_tag' in step &&
    (step._tag === 'catcher' || step._tag === 'catchType');
const isCatchTypeFunction = (catchFn) => catchFn._tag === 'catchType';
async function runAsyncPipe(history = [], a, ...args) {
    let currentValue = a;
    let lastSuccessfulValue = history.length > 0 ? history[history.length - 1] : a;
    let currentError = null;
    for (let i = 0; i < args.length; i++) {
        const step = args[i];
        if (isPromise(currentValue)) {
            currentValue = await currentValue;
        }
        if (isPipeReturn(currentValue)) {
            return currentValue.value;
        }
        try {
            if (isCatchFunction(step)) {
                if (currentError !== null) {
                    if (isCatchTypeFunction(step)) {
                        if (!(currentError instanceof step._targetError)) {
                            continue;
                        }
                    }
                    const result = step._handler(currentError, lastSuccessfulValue);
                    const resolvedResult = isPromise(result) ? await result : result;
                    currentError = null;
                    if (!isPipeReturn(resolvedResult)) {
                        lastSuccessfulValue = resolvedResult;
                    }
                    currentValue = result;
                    if (isPipeReturn(currentValue)) {
                        return currentValue.value;
                    }
                }
                else {
                    const result = step(currentValue);
                    if (isPromise(result)) {
                        currentValue = await result;
                    }
                    else {
                        currentValue = result;
                    }
                }
            }
            else {
                if (currentError === null) {
                    lastSuccessfulValue = currentValue;
                    const result = step(currentValue);
                    if (isPromise(result)) {
                        currentValue = await result;
                    }
                    else {
                        currentValue = result;
                    }
                    if (isPipeReturn(currentValue)) {
                        return currentValue.value;
                    }
                }
            }
        }
        catch (error) {
            currentError = error;
        }
    }
    if (currentError !== null) {
        throw currentError;
    }
    return currentValue;
}
asyncPipe.catch = catcher;
asyncPipe.catchType = catchType;
asyncPipe.return = createPipeReturn;
asyncPipe.throw = createPipeThrow;
asyncPipe.debug = (label = '') => tap((value) => console.log(label, value));
export { runAsyncPipe };
//# sourceMappingURL=asyncPipe.js.map